import {
  buildServices
} from './utils/build_services'
import buildParamList from './utils/build_params'
import {
  adaptCategoriesToStore
} from './adapters/categoryAdapter'
import { CONTENT } from '@/services/axios.config'

const services = [
  {
    name: 'listCategories',
    method: 'get',
    url: (params) => `/categories${buildParamList(params)}`,
    resolver: adaptCategoriesToStore
  },
  {
    name: 'getCategory',
    method: 'get',
    url: (params) => `/categories/${params.categoryId}`
  }
]

export const {
  listCategories,
  getCategory
} = buildServices(CONTENT, services)